module.exports = __webpack_public_path__ + "static/media/d3.87e64ad5.jpg";